<script setup lang="ts">
import HandyInfoBar from '@desktop/views/Relation/Sports/components/RelationView/Main/PitchWithIncidents/HandyInfoBar/HandyInfoBar.vue'
import PitchIncidents from '@desktop/views/Relation/Sports/components/RelationView/Main/PitchWithIncidents/PitchIncidents/PitchIncidents.vue'
import PitchWithIncidents from '@desktop/views/Relation/Sports/components/RelationView/Main/PitchWithIncidents/PitchWithIncidents.vue'

import PitchWithSideIncidents from './PitchWithSideIncidents/PitchWithSideIncidents.vue'
</script>

<template>
  <PitchWithIncidents>
    <HandyInfoBar />
    <PitchWithSideIncidents />
    <PitchIncidents />
  </PitchWithIncidents>
</template>
